import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'gatsby';

function Laverage(props) {
    return (
        <div className="laverage_section laverage_mobile_app p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>TekRevol’s Mobile App Development Workflow</h2>
                        <p>TekRevol's app development flows seamlessly from ideation to deployment. We prioritize collaboration, ensuring your vision transforms into a high-performing, user-centric mobile app effortlessly. Here are TekRevol’s proven steps for mobile app development:</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Plan</h6>
                                <p>We use scrum methodologies to construct a path for development prioritizing items from the backlog.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>Design</h6>
                                <p>We craft a user-friendly and visually appealing user interface in this phase.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Build</h6>
                                <p>Our mobile app developers transform the design into a functional application utilizing recent tech stack.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Launch</h6>
                                <p>Your mobile app is ready to make its debut in various stores, reaching its intended audience.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">05</div>
                                <h6>Maintenance</h6>
                                <p>We provide ongoing support and updates to keep your app up-to-date and responsive to your needs.</p>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;